<template>
    <div>
        <div class="flex flex-col space-y-6">
            <p class="text-justify text-lg md:text-xl">
                RO-Crate is a community effort to establish a lightweight
                approach to packaging research data with their metadata. It is
                based on schema.org annotations in JSON-LD, and aims to make
                best-practice in formal metadata description accessible and
                practical for use in a wide variety of situations.
            </p>

            <p class="text-center text-blue-700 text-xl md:text-3xl">
                An RO-Crate is a structured archive of all the items that
                contributed to the research outcome, including their
                identifiers, provenance, relations and annotations.
            </p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>
